/**
 * Export via server-side Puppeteer rendering.
 *
 * The backend uses a headless browser to render the design HTML,
 * producing pixel-perfect output identical to what the user sees.
 */

import { socialPostingService } from '../../../services/socialPosting';

export type ExportFormat = 'png' | 'jpeg';

export interface ExportOptions {
  format: ExportFormat;
  quality: number;
  scale: number;
  productId?: string;
}

// ── Public API ───────────────────────────────────────────────

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function exportDesign(
  postId: string,
  designId: string,
  filename: string,
  options: ExportOptions,
): Promise<void> {
  const blob = await socialPostingService.exportDesign(postId, designId, {
    format: options.format,
    quality: options.format === 'jpeg' ? Math.round(options.quality * 100) : 100,
    scale: options.scale,
    productId: options.productId,
  });

  const ext = options.format === 'jpeg' ? 'jpg' : 'png';
  downloadBlob(blob, `${filename}.${ext}`);
}
